import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   isTrPageReload: true,
   trainingListData: null,
   authData: null,
   isValidRecord: 1,
   selectedTrainingRecord: 'All Records',
};

const MyTrainingRecordSlice = createSlice({
   name: 'myTrRecord',
   initialState,
   reducers: {
      setIsTrPageReload: (state, action) => {
         state.isTrPageReload = action.payload;
      },
      setTrainingListData: (state, action) => {
         state.trainingListData = action.payload;
      },
      setTrAuthData: (state, action) => {
         state.authData = action.payload;
      },
      setTrIsValidRecord: (state, action) => {
         state.isValidRecord = action.payload;
      },
      setSelectedTrainingRecord: (state, action) => {
         state.selectedTrainingRecord = action.payload;
      },
   },
});

export const {setTrIsValidRecord} = MyTrainingRecordSlice.actions;
export const {setIsTrPageReload} = MyTrainingRecordSlice.actions;
export const {setTrainingListData} = MyTrainingRecordSlice.actions;
export const {setSelectedTrainingRecord} = MyTrainingRecordSlice.actions;
export const {setTrAuthData} = MyTrainingRecordSlice.actions;
export const getTrPageReLoad = state => state.myTrRecord.isTrPageReload;
export const getTrainingListData = state => state.myTrRecord.trainingListData;
export const getTrAuthData = state => state.myTrRecord.authData;
export const getTrIsValidRecord = state => state.myTrRecord.isValidRecord;
export const getSelectedTrainingRecord = state =>
   state.myTrRecord.selectedTrainingRecord;
export default MyTrainingRecordSlice.reducer;
